import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { PopupService } from 'src/app/services/popup.service';
import { WalletConnectService } from 'src/app/services/wallet-connect.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConnectComponent } from '../connect/connect.component';
import { SwapComponent } from '../swap/swap.component';
import { TranslateService } from '@ngx-translate/core';
import { EventService } from 'src/app/services/event.service';
import { convertNum, getClickId, languages } from 'src/app/shared/constants/app-enums';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ReferComponent } from '../refer/refer.component';
import { OwlOptions } from 'ngx-owl-carousel-o';
import SwiperCore, { SwiperOptions, Pagination, EffectCreative, EffectFade, EffectCube, EffectCards, EffectCoverflow, Autoplay } from 'swiper';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
SwiperCore.use([Pagination, EffectCube, EffectCreative, EffectCards, EffectCoverflow, Autoplay]);

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})

export class BannerComponent implements OnInit, OnDestroy {
  lang: any = localStorage.getItem('currentlang');

  private preSubscriptions: Subscription[] = [];
  private subscriptions: Subscription[] = [];
  modalRef?: BsModalRef;
  emailId = '';
  isMobile = (window.matchMedia && window.matchMedia('(max-device-width: 1024px)').matches) || screen.width <= 1024

  tokenSold = 0;
  totalTokens = 0;
  windowSize: number = 0;
  usdRaised = 0;
  currentStep = 0;
  selectedLanguage: any;

  connectInterval: any;
  usdtBal = 0;
  ethBal = 0;
  userClaimable: number = 0;
  refreshId: any;
  refreshRate: number = 5000;
  dataLoaded: boolean = false;
  isSoldOut: boolean = false;
  futureToken: number = 0;
  salePrice: number = 0.003;
  clickId: string = "";
  liveCounter: any;
  isLive: boolean = true;
  // liveDate: Date = new Date('2023/03/29 14:53:20');
  liveDate: Date = new Date('2023/05/24 12:00 UTC');

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private popupService: PopupService,
    private modalService: BsModalService,
    private walletConnectService: WalletConnectService,
    private eventService: EventService,
    private route: ActivatedRoute,

  ) {
    this.eventService.getLang().subscribe((val) => {
      this.lang = val || 'en';
    });
  }

  ngOnInit(): void {

    if (!this.isLive) {
      this.eventService.setCounter(this.liveDate);
      this.preSubscriptions.push(this.eventService.getCounter().subscribe((val) => {
        this.liveCounter = val;
      }));

      this.preSubscriptions.push(this.eventService.getEvent('PRESALE-END').subscribe((mode: boolean) => {
        this.isLive = true;
        this.walletConnectService.activateSite();
        setTimeout(() => {
          if (this.isLive) this.getBalanceData();
        }, this.refreshRate);

        for (const subscription of this.preSubscriptions) {
          subscription.unsubscribe();
        }
      }));
    } else {
      this.walletConnectService.activateSite();
      setTimeout(() => {
        if (this.isLive) this.getBalanceData();
      }, this.refreshRate);
    }


    this.clickId = getClickId();
    this.clickId = this.clickId != undefined ? this.clickId : "";


  }
  swiperOptions: SwiperOptions = {
    loop: true,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false
    // },
    mousewheel: {
      invert: true,
    },
    scrollbar: false,
    spaceBetween: 100,
    pagination: {
      el: '.tokensPagination',
      type: 'bullets',
      clickable: true
    },
    centeredSlides: true,
    effect: 'coverflow',
    coverflowEffect: {
      slideShadows: false,
      scale: 0.9,
      rotate: 0,
      stretch: 90,
      depth: 132,
      modifier: 1
    },
    slidesPerView: 2,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 50,
        coverflowEffect: {

          scale: 1,
          depth: 100,
          stretch: 130,
        },
      },
      940: {
        slidesPerView: 3,
      }

    },
  };

  slideOption: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    margin: 0,
    dots: false,
    nav: false,
    center: true,
    items: 3,
    // navText: ["<img src='/assets/images/arrow-left-icon.svg'>", "<img src='/assets/images/arrow-right-icon.svg'>"],
    responsive: {
      0: {
        items: 1.9,
        nav: false,

      },
      940: {
        items: 3,
      },
      540: {
        items: 3,
      }
    },
  };
  getBalanceData() {
    const balanceData: any = this.walletConnectService.balanceData;
    this.currentStep = balanceData.currentStep;
    this.tokenSold = balanceData.totalTokensSold;
    this.totalTokens = this.tokenSoldData.maxAmount;
    this.ethBal = balanceData.nativeBal;
    this.usdtBal = balanceData.usdtBal;
    this.usdRaised = balanceData.usdRaised;
    this.userClaimable = balanceData.userClaimable;
    this.isSoldOut = this.tokenSold > this.walletConnectService.tokenomics[this.walletConnectService.tokenomics.length - 1].maxToken ? true : false;
    this.dataLoaded = true;

    this.getFutureToken();
    if (this.refreshId) clearTimeout(this.refreshId);
    this.refreshId = setTimeout(() => this.getBalanceData(), this.refreshRate);
  }

  submit() {
    let req = { email: this.emailId, listId: environment.newsLetterListId };
    this.subscriptions.push(this.http.post(environment.newsLetterURL, req).subscribe((res) => {
      this.popupService.messagePopup("success", this.translate.instant("newsletter_thanks")).then(() => {
      });
      this.emailId = '';
    }));
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static'
    });
  }

  connectWeb3Auth(): void {
    this.walletConnectService.connectWallet('web3auth');
  }

  get tokenLeft() {
    let num = this.tokenSoldData.maxToken - this.tokenSold;
    num = +((+num).toFixed(2));
    let nf = new Intl.NumberFormat('en-US');
    nf.format(num); // "1,234,567,890"
    return nf.format(num > 0 ? num : 0);
  }

  convertNum(amount: number) {
    return convertNum(amount);
  }

  openSwap(isNative: boolean = true, isWert: boolean = false): void {
    this.modalRef?.hide();
    if (this.checkChain() && !this.isSoldOut) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "workflowStep",
        workflowName: "swap",
        workflowStepNumber: 1,
        workflowStepName: "swapAmount",
        workflowCompleteFlag: 0,
        workflowErrorCode: 0,
        walletAddress: this.walletAddress
      });
      this.modalRef = this.modalService.show(SwapComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
        initialState: { isNative: isNative, isWert: isWert }
      });

      this.subscriptions.push(this.modalRef.content.messageEvent.subscribe((message: any) => {
        console.log('Child component\'s event was triggered', message);
        if (message && message === 'startAgain') {
          this.openSwap(isNative);
        }
      }));
    }
  }

  isCorrectChain() {
    return this.walletConnectService.isCorrectChain()
  }

  checkChain() {
    if (this.isCorrectChain()) {
      return true;
    } else {
      this.popupService.messagePopup(
        "info",
        this.translate.instant('wrong_chain', { chainName: this.eventService.isBsc ? environment.bsc.chainName : environment.eth.chainName }),
        this.translate.instant('change_network'))
        .then((res) => {
          if (res.isConfirmed) {
            this.walletConnectService.switchNetwork(this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt);
          }
        });
      return false;
    }
  }

  changeChain(): void {
    this.walletConnectService.switchNetwork(!this.eventService.isBsc ? environment.bsc.chainIdInt : environment.eth.chainIdInt);
  }

  getFutureToken() {
    let step = +this.currentStep;
    if (step != (this.walletConnectService.tokenomics.length - 1)) {
      this.futureToken = this.walletConnectService.tokenomics[step + 1].tokenUSDT;
    } else {
      this.futureToken = this.tokenSoldData.tokenUSDT;
    }
    this.salePrice = this.tokenSoldData.tokenUSDT;
  }

  get raisedPercent() {
    let percent = (this.usdRaised / this.tokenSoldData.maxAmount) * 100;
    return (percent >= 100 ? 100 : percent) + '%';
  }

  get tokenSoldData() {
    return this.walletConnectService.tokenSoldData;
  }

  get walletAddress(): any {
    return this.walletConnectService.walletAddress;
  }

  get tokenPercent() {
    let percent = (this.tokenSold / this.tokenSoldData.maxToken) * 100; //for presale
    return (percent >= 100 ? 100 : +(percent.toFixed(2))) + "%";
  }
  get tokenRemain() {
    return this.tokenSoldData.maxToken - this.tokenSold;

  }

  get isBsc() {
    return this.eventService.isBsc;
  }

  get tokenName() {
    return environment.tokenName;
  }

  getReferralURL() {
    const data = {
      walletAddress: this.walletAddress,
      iid: environment.iidDashFx,
    }
    this.subscriptions.push(this.http.post(environment.dashFxReferral, data).subscribe((res: any) => {
      console.log('DashFx success response', res);
      this.modalRef = this.modalService.show(ReferComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
        initialState: { url: res.data.url }

      });
    },
      (err: any) => {
        console.log('DashFx error response', err);
      }))
  }
  ngOnDestroy(): void {
    for (const subscription of this.preSubscriptions) {
      subscription.unsubscribe();
    }

    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  slideOption1: OwlOptions = {
    loop: true,
    // mouseDrag: false,
    // touchDrag: false,
    dots: false,
    nav: false,
    autoWidth: true,
    autoplay: true,
    center: false,
    responsive: {
      0: {
        items: 1.2,
      },
    },
  };
  items = [
    {
      img: '/assets/images/featured/logo (1).svg'
    },
    {
      img: '/assets/images/featured/logo (2).svg'
    },
    {
      img: '/assets/images/featured/logo (3).svg'
    },
    {
      img: '/assets/images/featured/logo (4).svg'
    },
    {
      img: '/assets/images/featured/logo (5).svg'
    },
    {
      img: '/assets/images/featured/logo (6).svg'
    },
    {
      img: '/assets/images/featured/logo (7).svg'
    }
  ]
  //--------------------------------------------------------

  getHeadingStyles(): FontStyles | undefined {
    // Define font sizes and line heights for different languages
    const desktopStyles: Record<string, FontStyles> = {
      en: { 'font-size': '72px', 'line-height': '1.2' },
      // Add styles for other languages here
      // For example, 'fr' for French:
      ar: { 'font-size': '40px', 'line-height': '50px' },
      'zh-hans': { 'font-size': '40px', 'line-height': '50px' },
      'zh-hant': { 'font-size': '40px', 'line-height': '50px' },
      bg: { 'font-size': '40px', 'line-height': '50px' },
      cz: { 'font-size': '40px', 'line-height': '50px' },
      nl: { 'font-size': '40px', 'line-height': '50px' },
      fr: { 'font-size': '40px', 'line-height': '50px' },
      de: { 'font-size': '40px', 'line-height': '50px' },
      hu: { 'font-size': '40px', 'line-height': '50px' },
      id: { 'font-size': '40px', 'line-height': '50px' },
      it: { 'font-size': '40px', 'line-height': '50px' },
      jp: { 'font-size': '40px', 'line-height': '50px' },
      kr: { 'font-size': '40px', 'line-height': '50px' },
      pl: { 'font-size': '40px', 'line-height': '50px' },
      pt: { 'font-size': '40px', 'line-height': '50px' },
      ro: { 'font-size': '40px', 'line-height': '50px' },
      ru: { 'font-size': '40px', 'line-height': '50px' },
      sk: { 'font-size': '40px', 'line-height': '50px' },
      es: { 'font-size': '40px', 'line-height': '50px' },
      th: { 'font-size': '40px', 'line-height': '50px' },
      tr: { 'font-size': '40px', 'line-height': '50px' },
      vn: { 'font-size': '40px', 'line-height': '50px' },
    };

    // Check if the screen width is above 1024px (desktop)
    const isDesktop = window.innerWidth > 1024;

    // Get the current language from your component's property
    const currentLanguage = this.lang || ('en');

    // Return the styles based on the current language and screen width
    if (isDesktop && desktopStyles[currentLanguage]) {
      return desktopStyles[currentLanguage];
    } else {
      return undefined; // Return undefined for languages other than English on desktop
    }
  }
  options: AnimationOptions = {
    path: '/assets/lottie/Motion 4 -16.json'
  };
  onAnimate(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
  styles: Partial<CSSStyleDeclaration> = {
    // width: '300px',
    // height: '750px',
  };
  // ------------------
  // for mobile
  // optionsMob: AnimationOptions = {
  //   path: '/assets/lottie/Motion_mobile.json'
  // };

}

type FontStyles = {
  'font-size': string;
  'line-height': string;
};